// components/VisibilityToggle.js
//
// Usage in MaterialRequestsPage:
//   import VisibilityToggle from '../components/VisibilityToggle';
//   const [visibility, setVisibility] = useState('public');
//   <VisibilityToggle value={visibility} onChange={setVisibility} />

import React from 'react';
import './VisibilityToggle.css';

function VisibilityToggle({ value, onChange }) {
  return (
    <div className="vt-wrapper">
      <p className="vt-label">Who can see this material?</p>
      <div className="vt-options">

        <label className={`vt-option ${value === 'private' ? 'vt-option--active' : ''}`}>
          <input
            type="radio"
            name="visibility"
            value="private"
            checked={value === 'private'}
            onChange={() => onChange('private')}
          />
          <div className="vt-option__body">
            <div className="vt-option__header">
              <span className="vt-option__icon">🔒</span>
              <span className="vt-option__title">Keep private to my account</span>
            </div>
            <p className="vt-option__desc">
              Goes straight to Nezo for you and everyone on your Nezo account
              (and your Ops Console team, if you have one).
            </p>
          </div>
        </label>

        <label className={`vt-option ${value === 'public' ? 'vt-option--active' : ''}`}>
          <input
            type="radio"
            name="visibility"
            value="public"
            checked={value === 'public'}
            onChange={() => onChange('public')}
          />
          <div className="vt-option__body">
            <div className="vt-option__header">
              <span className="vt-option__icon">🌐</span>
              <span className="vt-option__title">Submit for public use</span>
            </div>
            <p className="vt-option__desc">
              Reviewed by the Nezo team, then available to all users in your region.
            </p>
          </div>
        </label>

      </div>
    </div>
  );
}

export default VisibilityToggle;
